var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "fieldset",
      [
        _c("h3", { staticClass: "modal-title" }, [
          _vm._v("ADD APPLICATION TO GROUP")
        ]),
        _vm._v(" "),
        _c(
          "b-form-group",
          { class: { "error-input": _vm.$v.application.$error } },
          [
            _c("label", [_vm._v(" Application ")]),
            _vm._v(" "),
            _c("j-single-select", {
              attrs: {
                options: _vm.list_application,
                placeholder: "Select Application",
                "error-required": false,
                "value-format": "object"
              },
              model: {
                value: _vm.application,
                callback: function($$v) {
                  _vm.application = $$v
                },
                expression: "application"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pull-right m__t--20" },
          [
            _c(
              "b-button",
              { staticClass: "btn", on: { click: _vm.closeMappingModal } },
              [_vm._v("\n        Close\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "btn",
                attrs: { variant: "primary" },
                on: { click: _vm.createMapping }
              },
              [_vm._v("\n        Confirm\n      ")]
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68fc2f3b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68fc2f3b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/setting/jModalMappingAppsGroup.vue
// module id = null
// module chunks = 